import { StoryAbstract } from './StoryAbstract';

export type StoryType = 'photo' | 'video' | 'blur';

export type Story = {
  url: string;
  type: StoryType;
  Component?: React.FunctionComponent;
};

export interface StoriesProgressRef {
  updateProgressLine: (progress: number) => void;
}

export const EdgeReachedDirection = {
  Left: -1,
  Right: 1,
};

export type EdgeReachedDirection = (typeof EdgeReachedDirection)[keyof typeof EdgeReachedDirection];

export class StoryLoadError extends Error {
  name = 'StoryLoadError';
  readonly type: StoryType;

  constructor(type: StoryType, suffix?: string) {
    super();
    this.type = type;

    if (suffix) {
      this.name += `_${suffix}`;
    }

    this.message = `[${type}]`;
  }
}

export type AbstractStoryDetails = Pick<
  StoryAbstract,
  'type' | 'renderComponent' | 'element' | 'duration' | 'currentTime' | 'status' | 'url' | 'manualReplayUsed'
>;
export type StoriesPlayerStatus =
  | 'idle'
  | 'loading'
  | 'failed'
  | 'playing'
  | 'paused'
  | 'suspend'
  | 'finished'
  | 'inited';

export type CurrentIndexChangedHandler = (index: number, type?: StoryType) => void;
export type StoryStatusChangedHandler = (index: number, isCurrent: boolean, story: AbstractStoryDetails) => void;

export type StoriesPlayerEmitterEvents = {
  currentIndexChanged: CurrentIndexChangedHandler;
  storyStatusChanged: StoryStatusChangedHandler;
};
